import { AppStoreButtonView } from "@/FluidPreview/Elements/AppStoreButton";
import { TextView } from "@/FluidPreview/Elements/Text";
import { ButtonView } from "@/FluidPreview/Elements/Button";
import { CounterView } from "@/FluidPreview/Elements/Counter";
import { ImageView } from "@/FluidPreview/Elements/Image";
import { SocialLinksView } from "@/FluidPreview/Elements/SocialLinks";
import { VideoView } from "@/FluidPreview/Elements/Video";
import { FormView } from "@/FluidPreview/Elements/Form";
import { EmbedView } from "@/FluidPreview/Elements/Embed";
import { MapView } from "@/FluidPreview/Elements/Map";

export const ElementsPreview = {
  Text: TextView,
  Heading: TextView,
  Button: ButtonView,
  Image: ImageView,
  Video: VideoView,
  AppStoreButton: AppStoreButtonView,
  SocialLinks: SocialLinksView,
  Counter: CounterView,
  Form: FormView,
  Embed: EmbedView,
  Map: MapView,
};
